<script>
  import PackageImage from './PackageImage.svelte'
  import WhiteSpace from '../UI/WhiteSpace.svelte'
</script>

<div id="top">
  <WhiteSpace />
</div>
<PackageImage />
